module.exports = __webpack_public_path__ + "files/2081d303ef9be3ddf720918c0ad2d079.svg";